import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, List, ListItemButton, ListItemText, TextField} from '@mui/material';
import {Add, Delete, Save} from '@mui/icons-material';
import filterService from '../../services/NotificatioFilterService';
import {useSnackbar} from '../../util/SnackbarProvider';

const FilterPanel = forwardRef(({type, onFilterSelect, currentSearchParams}, ref) => {

    useImperativeHandle(ref, () => ({
        resetSelection: () => setSelectedIndex(null)
    }));

    const {sendAlertMessage} = useSnackbar();
    const [filters, setFilters] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [open, setOpen] = useState(false);
    const [isNewFilter, setIsNewFilter] = useState(false);

    const retrieveFilters = () => {
        filterService.search({type})
            .then(response => setFilters(response))
            .catch(err => console.error(err));
    };

    useEffect(() => {
        retrieveFilters();
    }, []);

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
        const filter = filters[index];
        if (filter) onFilterSelect(JSON.parse(filter.data));
    };

    const handleDialogOpen = (isNew) => {
        setIsNewFilter(isNew);
        setOpen(true);
    };

    const handleDialogClose = () => {
        setOpen(false);
    };

    const createNewFilter = (name) => {
        filterService.create({name, data: JSON.stringify(currentSearchParams), type})
            .then(() => {
                sendAlertMessage("Szűrő sikeresen létrehozva");
                retrieveFilters();
            })
            .catch(error => sendAlertMessage(error?.message || "Szűrő létrehozása sikertelen", 'error'));
    };

    const updateFilter = (name) => {
        filterService.update(filters[selectedIndex].id, {name, data: JSON.stringify(currentSearchParams)})
            .then(() => {
                sendAlertMessage("Szűrő sikeresen mentve");
                retrieveFilters();
            })
            .catch(error => sendAlertMessage(error?.message || "Szűrő mentése sikertelen", 'error'));
    };

    const deleteFilter = () => {
        filterService.delete(filters[selectedIndex].id)
            .then(() => {
                sendAlertMessage("Szűrő sikeresen törölve");
                retrieveFilters();
            })
            .catch(error => sendAlertMessage(error?.message || "Szűrő törlése sikertelen", 'error'));
    };

    return (
        <>
            <Grid container columns={5} rowSpacing={1} columnSpacing={2}>
                <Grid size={{xs: 3}}>
                    <Box sx={{
                        backgroundColor: '#FFFDD0',
                        border: "1px solid gray",
                        borderRadius: "8px",
                        minHeight: "130px"
                    }}>
                        <List component="nav">
                            {filters.map((filter, index) => (
                                <ListItemButton key={index}
                                                selected={selectedIndex === index}
                                                onClick={(event) => handleListItemClick(event, index)}>
                                    <ListItemText primary={filter.name}/>
                                </ListItemButton>
                            ))}
                        </List>
                    </Box>
                </Grid>
                <Grid size={{xs: 2}}>
                    <Button variant="contained" color={"success"} fullWidth
                            onClick={() => handleDialogOpen(true)}
                            style={{height: "36px", margin: "0px", position: "relative"}}>
                        <Add style={{position: "absolute", left: 10}}/>
                        Új
                    </Button>
                    <Button variant="contained" fullWidth onClick={() => handleDialogOpen(false)}
                            style={{height: "36px", marginTop: "10px", position: "relative"}}
                            disabled={selectedIndex == null}>
                        <Save style={{position: "absolute", left: 10}}/>
                        Mentés
                    </Button>
                    <Button variant="contained" color={"error"} fullWidth onClick={deleteFilter}
                            style={{height: "36px", marginTop: "10px"}}
                            disabled={selectedIndex == null}>
                        <Delete style={{position: "absolute", left: 10}}/>
                        Törlés
                    </Button>
                </Grid>
            </Grid>

            <Dialog open={open} onClose={handleDialogClose}
                    PaperProps={{
                        component: 'form',
                        onSubmit: (e) => {
                            e.preventDefault();
                            const formData = new FormData(e.currentTarget);
                            const name = formData.get('name');
                            isNewFilter ? createNewFilter(name) : updateFilter(name);
                            handleDialogClose();
                        },
                    }}>
                <DialogTitle>Adj meg egy nevet</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus required fullWidth margin="dense"
                        name="name"
                        label="Szűrő neve"
                        defaultValue={isNewFilter ? '' : filters[selectedIndex]?.name}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="error" variant="outlined">Mégse</Button>
                    <Button type="submit" variant="contained">Mentés</Button>
                </DialogActions>
            </Dialog>
        </>
    );
})

export default FilterPanel;